<template>
  <div class="list_box">
    <div class="list_item" v-for="item in infoList" :key="item.activityId" @click="clickComm(item)">
      <div class="leftImg">
        <van-image round fit="cover" width="100%" height="100%" :src="item.mainImage"/>
      </div>
      <div class="rightBox">
        <div class="title" style="font-size: 15px">{{ item.name }}</div>
        <div style="color: #1874dd;font-weight: bold;font-size: 15px;margin-top: 8px">{{ item.remark }}</div>
        <!--        <div class="other">-->
        <!--          <div class="price">￥{{ dealPrice(item.priceList) }}</div>-->
        <!--          <div class="num" v-if="item.enrollShow == '1'">已有{{ item.enrollment || 0 }}报名</div>-->
        <!--        </div>-->
      </div>
    </div>
    <van-empty v-if="infoList != null && infoList.length == 0" image="search" description="暂无信息"/>


    <div
      v-if="openSelect"
      style="position: fixed;top: 0;left: 0;z-index: 2000;width: 100%;height: 100%;background-color: rgba(0,0,0,.7);"
      class="fx-cen-cen">

      <!--查询成绩-->
      <div v-if="!openOpus" style="width: 356px;height: 458px;background: #FFFFFF;border-radius: 8px;margin-top: 80px"
           class="fx-col fx-sta-cen">
        <div style="width: 100%;height: auto" class="fx-cen-cen">
          <img src="../assets/img/hand.png" style="width: 180px;height: 180px;margin-top: -90px">
        </div>

        <div class="fx-sta" style="width: 100%;margin-left: 40px">
          <div class="label fx-cen-cen" style="line-height: 30px">姓名：</div>
          <input placeholder="请输入姓名" style="line-height: 30px;border: none" v-model="userName"
                 maxlength="5"></input>
        </div>
        <div style="width: 320px;height: 1px;background: #DCDFE6;"></div>


        <div class="fx-sta" style="width: 100%;margin-left: 40px;margin-top: 30px;">
          <div class="label fx-sta-cen" style="line-height: 30px">身份证号：</div>
          <input placeholder="请输入身份证号" style="line-height: 30px;border: none" v-model="idCardNumber"
                 maxlength="18"></input>
        </div>
        <div style="width: 320px;height: 1px;background: #DCDFE6;"></div>

        <div class="btn fx-cen-cen" style="margin-top: 50px" @click="queryOpus('score')">成绩查询</div>
        <div class="btn fx-cen-cen" @click="queryOpus('delivery')">快递信息查询</div>


        <!-- 新增第 48 行内容 -->
        <div style="display: flex;font-size: 12px; align-items: center; margin-top: 5px; margin-left: 20px;">
          <input type="checkbox" v-model="isAgreed">
          <span>我已阅读并同意</span>
          <span @click="showWebView('userAgreement')"
                style="color: #1874dd; margin: 0 1px; cursor: pointer;">《用户服务协议》</span>
          <span>和</span>
          <span @click="showWebView('privacyPolicy')"
                style="color: #1874dd; margin-left: 2px; cursor: pointer;">《隐私政策》</span>
        </div>

        <div style="width: 100px;height: 42px;font-size: 18px;color: #767676;margin-top: 15px" class="fx-cen-cen"
             @click="openSelect=false">返回
        </div>
      </div>


      <!--查询成绩有数据-->
      <div v-if="openOpus" style="width: 356px;height: 458px;background: #FFFFFF;border-radius: 8px;margin-top: 80px"
           class="fx-col fx-sta-cen">
        <div style="width: 100%;height: auto" class="fx-cen-cen">
          <img src="../assets/img/hand.png" style="width: 180px;height: 180px;margin-top: -90px">
        </div>
        <div style="color: #3D3D3D;font-size: 18px;font-weight: bold;margin-bottom: 10px">请选择您要查询的作品</div>

        <div v-for=" (item,index) in opus" @click="goOpus(item,index)"
             style="color: #FF7216;font-size: 16px;border-bottom: 1px solid #FF7216;margin-top: 15px">
          {{ item.opusName }}
        </div>

        <div class="fx1"></div>
        <div @click="openOpus=false"
             style="width: 100px;height: 42px;font-size: 18px;color: #767676;margin-bottom: 30px" class="fx-cen-cen">
          返回
        </div>
      </div>

      <!-- 新增 WebView 组件 -->
      <div v-if="showWebViewModal"
           style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.7); display: flex; justify-content: center; align-items: center;">
        <!-- 给内容容器添加相对定位，方便计算关闭按钮位置 -->
        <div
          style="width: 80%; height: 80%; background: white; border-radius: 8px; padding: 20px; position: relative; overflow-y: auto;">
          <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">{{ currentAgreementTitle }}</div>
          <div v-html="agreementContent"></div>
        </div>
        <!-- 调整关闭按钮样式，使用 fixed 定位 -->
        <div @click="hideWebView"
             style="position: fixed; top: calc(10% + 10px); right: calc(10% + 10px); cursor: pointer; font-size: 20px; color: white; background: rgba(0, 0, 0, 0.5); width: 30px; height: 30px; border-radius: 50%; display: flex; justify-content: center; align-items: center;">
          ×
        </div>
      </div>

      <!--      <div v-if="showWebViewModal"-->
      <!--           style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.7); display: flex; justify-content: center; align-items: center;">-->
      <!--        <div-->
      <!--          style="width: 80%; height: 80%; background: white; border-radius: 8px; padding: 20px; position: relative; overflow-y: auto;">-->
      <!--          &lt;!&ndash;          <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">{{ currentAgreementTitle }}</div>&ndash;&gt;-->
      <!--          <div v-html="agreementContent"></div>-->
      <!--          <div @click="hideWebView"-->
      <!--               style="position: absolute; top: 10px; right: 10px; cursor: pointer; font-size: 20px;">×-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div v-if="showWebViewModal"-->
      <!--           style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.7); display: flex; justify-content: center; align-items: center;">-->
      <!--        <div style="width: 80%; height: 80%; background: white; border-radius: 8px; padding: 20px; position: relative;">-->
      <!--          <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">{{ currentAgreementTitle }}</div>-->
      <!--          <iframe :src="currentAgreementUrl" style="width: 100%; height: calc(100% - 40px); border: none;"></iframe>-->
      <!--          <div @click="hideWebView"-->
      <!--               style="position: absolute; top: 10px; right: 10px; cursor: pointer; font-size: 20px;">×-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

    </div>

  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
  name: 'InfoList',
  props: ['infoList'],
  data() {
    return {
      openSelect: false,
      openOpus: false,
      userName: "",
      idCardNumber: "",
      queryType: "",
      clickItem: {},
      opus: [],
      id: 0,
      isAgreed: false, // 新增复选框状态
      showWebViewModal: false, // 新增 WebView 显示状态
      currentAgreementTitle: '', // 新增当前协议标题
      agreementContent: '', // 协议内容
      currentAgreementUrl: '', // 新增当前协议 URL
      yinsizhengce: `
          <h2>《隐私政策》</h2>
          <h3>一、引言</h3>
          <p>本隐私政策旨在向您（以下简称“用户”）说明[长春凡星文化传播有限公司]（以下简称“我们”）如何收集、使用、存储、共享、保护和处理您的个人信息，以及您享有的相关权利。我们深知个人信息对您的重要性，并将严格按照法律法规的要求，采取必要的安全措施，保障您的个人信息安全。</p>
          <p>在您使用我们的[凡星艺彩系统]（以下简称“本服务”）之前，请务必仔细阅读本隐私政策的全部内容。一旦您开始使用本服务，即表示您已充分理解并同意接受本隐私政策的约束。若您不同意本隐私政策的任何内容，请立即停止使用本服务。</p>

          <h3>二、个人信息的定义</h3>
          <p>本隐私政策中所称“个人信息”，是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。个人信息包括但不限于您的姓名、身份证号码、手机号码、电子邮箱地址、设备信息、位置信息、交易记录等。</p>

          <h3>三、我们收集的个人信息及收集方式</h3>
          <h4>（一）您主动提供的个人信息</h4>
          <p>活动报名：当您进行活动报名时，可能需要向我们提供您的姓名、性别、身份证号、联系方式等个人信息。</p>
          <p>信息查询：在您查询比赛成绩，下载电子版活动、考级证书，查看邮寄单号时，需要向我们提供您的姓名及身份证号码以进行信息匹配。</p>
          <p>使用特定功能：在本服务中，某些特定功能可能需要您提供额外的个人信息才能使用。例如，当您使用在线支付功能时，需要提供银行卡号、有效期、CVv 码等支付信息；当您参与我们的问卷调查或活动时，可能需要提供您的意见、建议、联系方式等信息。</p>
          <h4>（二）我们在您使用服务过程中自动收集的个人信息</h4>
          <p>设备信息：当您使用本服务时，我们会自动收集您设备的型号、操作系统版本、设备标识符（如 IMEI、MAC 地址、Android ID 等）、设备设置、设备环境信息等。这些信息有助于我们优化本服务的性能，确保其在不同设备上的兼容性和稳定性。</p>
          <p>日志信息：我们会记录您在使用本服务过程中的操作日志，包括您的访问时间、访问页面、点击行为、浏览时长等信息。通过分析这些日志信息，我们可以了解您的使用习惯和需求，改进本服务的功能和用户体验。</p>
          <p>位置信息：在您授权的情况下，我们会收集您的位置信息，以便为您提供基于地理位置的服务，如附近的商家推荐、位置导航等。您可以在设备的设置中随时关闭位置权限，停止向我们提供位置信息。</p>
          <p>Cookie 和类似技术：为了提升您的使用体验和保障服务的安全，我们可能会在您的设备上存储一些小型数据文件，即 Cookie。Cookie 可以帮助我们识别您的设备，记录您的偏好设置，实现会话管理等功能。同时，我们也可能使用类似 Cookie 的技术，如像素标签、本地存储等，来实现类似的目的。您可以通过修改浏览器的设置来拒绝或清除 Cookie，但这可能会影响您对本服务的使用。</p>

          <h3>四、我们如何使用个人信息</h3>
          <h4>（一）提供和改进服务</h4>
          <p>我们使用您提供的个人信息来创建和管理您的账户，为您提供本服务的各项功能，如浏览信息、发布内容、进行交易等。同时，我们会根据您使用本服务的情况，不断优化和改进本服务的功能和性能，提升您的使用体验。</p>
          <h4>（二）个性化推荐</h4>
          <p>通过分析您的个人信息和使用行为，我们会为您提供个性化的内容推荐和服务。例如，根据您的浏览历史和兴趣偏好，为您推荐相关的文章、产品或活动。您可以根据自己的需求在设置中调整个性化推荐的偏好设置。</p>
          <h4>（三）沟通与互动</h4>
          <p>我们会使用您的联系方式与您进行沟通和互动，如发送服务通知、回复您的咨询和反馈、邀请您参与调查或活动等。在必要时，我们也会通过电话、短信等方式与您取得联系，但我们会严格遵守相关法律法规的要求，不会过度打扰您。</p>
          <h4>（四）安全保障</h4>
          <p>为了保障本服务的安全稳定运行，防止欺诈、恶意攻击等违法行为的发生，我们会使用您的个人信息进行安全监测和风险评估。例如，通过分析您的登录行为和交易记录，识别异常操作并及时采取措施进行防范。</p>
          <h4>（五）法律合规</h4>
          <p>在符合法律法规要求的情况下，我们可能会使用您的个人信息来履行我们的法律义务，如配合司法机关的调查取证、响应监管机构的合规要求等。</p>

          <h3>五、个人信息的共享、转让与公开披露</h3>
          <h4>（一）共享</h4>
          <p>我们承诺不会将您的个人信息出售给任何第三方。但在以下情况下，我们可能会与第三方共享您的个人信息：</p>
          <p>获得您的明确同意：在共享您的个人信息前，我们会事先获得您的明确授权同意，并向您详细说明共享的目的、范围和接收方等信息。</p>
          <p>与合作伙伴共享：为了提供更完善的服务，我们可能会与合作伙伴共享您的部分个人信息。例如，与物流合作伙伴共享您的收货地址和联系方式，以便为您配送商品；与支付机构共享您的支付信息，以便完成交易支付。我们会与合作伙伴签订严格的保密协议，要求他们按照本隐私政策的规定保护您的个人信息，并仅将您的个人信息用于提供相关服务的目的。</p>
          <p>为履行法定义务或维护合法权益共享：在符合法律法规要求的情况下，我们可能会为了履行法定义务（如响应政府部门的合法要求、配合司法机关的调查等）或维护我们的合法权益（如防止欺诈、保护用户安全等）而与第三方共享您的个人信息。</p>
          <h4>（二）转让</h4>
          <p>随着我们业务的持续发展，我们可能会发生合并、收购、资产转让等交易。在涉及个人信息转让时，我们会向您告知相关情况，并要求新的持有您个人信息的公司或组织继续受本隐私政策的约束。如果本隐私政策中规定的个人信息的收集、使用方式发生变更，我们会重新获得您的授权同意。</p>
          <h4>（三）公开披露</h4>
          <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
          <p>获得您的明确同意：在获得您的明确授权同意后，我们会按照您指定的方式和范围公开披露您的个人信息。</p>
          <p>法律法规要求：在法律、法规、规范性文件及政府主管部门的强制性要求下，我们可能会公开披露您的个人信息。</p>

          <h3>六、个人信息的存储与保护</h3>
          <h4>（一）存储地点</h4>
          <p>我们会将您的个人信息存储在位于[阿里云]的服务器上。我们会采取必要的安全措施，确保您的个人信息在存储过程中的安全性和保密性。</p>
          <h4>（二）保护措施</h4>
          <p>我们高度重视您的个人信息安全，采取了多种技术和管理措施来保护您的个人信息免受未经授权的访问、使用、披露、篡改或丢失。具体措施包括但不限于：</p>
          <p>数据加密：对您的敏感个人信息（如支付信息、密码等）进行加密存储和传输，确保信息在传输和存储过程中的安全性。</p>
          <p>访问控制：建立严格的访问控制机制，对能够访问您个人信息的人员进行权限管理，只有经过授权的人员才能访问您的个人信息，并且我们会记录访问操作日志，以便进行审计和追踪。</p>
          <p>安全审计：定期对本服务的安全性和个人信息保护措施进行审计和评估，及时发现和解决潜在的安全隐患。</p>
          <p>员工培训：加强对员工的个人信息保护培训，提高员工的安全意识和保密意识，确保员工严格遵守本隐私政策和相关的安全规定。</p>
          <h4>（三）安全事件处理</h4>
          <p>尽管我们采取了上述安全措施，但无法保证绝对的信息安全。如果发生个人信息泄露等安全事件，我们将及时启动应急预案，采取合理的补救措施，并按照法律法规的要求及时通知您。同时，我们会配合相关部门进行调查和处理，尽可能降低安全事件对您的影响。</p>

          <h3>七、未成年人个人信息保护</h3>
          <p>我们非常重视对未成年人个人信息的保护。如果您是未成年人，请务必在您的监护人陪同下阅读本隐私政策，并在取得监护人同意后使用本服务。我们将根据国家相关法律法规的规定，对未成年人的个人信息采取特殊的保护措施。</p>
          <p>如果我们发现收集的个人信息属于未成年人且未事先获得其监护人同意的，我们将尽快删除相关信息。如果您作为监护人发现未成年人在未经您同意的情况下使用了本服务并提供了个人信息，您可以随时联系我们，我们将协助您处理相关事宜。</p>

          <h3>八、隐私政策的更新与修改</h3>
          <p>为了适应法律法规的要求和业务发展的需要，我们可能会不时对本隐私政策进行更新和修改。我们会在本服务的相关页面上发布更新后的隐私政策，并通过适当的方式通知您。请您定期查看本隐私政策，以了解最新的内容。如果您继续使用本服务，即表示您同意接受更新后的隐私政策的约束。</p>
        `,
      fuwuxieyi: `
        <h2>《用户服务协议》</h2>
        <p>用户：使用本小程序服务的自然人、法人或其他组织（以下简称“您”）；</p>
        <p>运营方：长春凡星文化传播有限公司（统一社会信用代码：[91220101309903793X]，以下简称“我们”）。</p>

        <h3>第一条 定义与解释</h3>
        <p>1.1 本服务：指我们通过[凡星艺彩系统]向您提供的基于身份证号码和姓名的活动报名和证书信息查询、快递物流单号查询（邮寄证书、奖杯、门票时使用）服务，包括但不限于证书核验、结果展示及相关技术支持。</p>
        <p>1.2 用户数据：指您在使用本服务过程中主动提供的姓名、身份证号码等个人信息，以及我们为提供服务而记录的设备信息、操作日志等（详见《隐私政策》）。</p>
        <p>1.3 第三方服务：指我们为提供本服务而接入的政府机构、认证机构、云服务提供商等合作伙伴的服务。</p>

        <h3>第二条 服务内容与使用规则</h3>
        <h4>2.1 服务范围</h4>
        <p>您可通过输入真实姓名及身份证号码进行活动报名或查询与该身份关联的证书信息（如比赛、展演、艺术考级等）、快递物流单号信息（邮寄证书时使用）；</p>
        <p>我们承诺仅展示经合法授权或公开渠道获取的证书信息，并确保数据实时性及准确性。</p>
        <h4>2.2 使用条件</h4>
        <p>您需年满18周岁且具备完全民事行为能力；若您为未成年人，需在监护人陪同下使用本服务；</p>
        <p>您应确保输入的身份证号码、姓名等信息真实、完整、有效，不得冒用他人身份或提供虚假信息；</p>
        <p>未经授权将本服务用于商业目的（如批量查询、数据爬取）。</p>
        <h4>2.3 服务变更与终止</h4>
        <p>我们有权根据业务调整、技术升级或法律法规要求，暂停、修改或终止部分或全部服务，并通过小程序公告、邮件或其他方式提前通知您；</p>

        <h3>第三条 用户权利与义务</h3>
        <h4>3.1 用户权利</h4>
        <p>您有权根据本协议及《隐私政策》的约定，使用本服务进行相关活动报名或查询个人证书信息、物流快递信息；</p>
        <p>您有权要求我们解释服务规则、收费标准（如有）及数据处理流程；</p>
        <p>您有权通过客服渠道（[联系方式]）反馈服务问题或投诉违规行为。</p>
        <h4>3.2 用户义务</h4>
        <p>您应妥善保管账号及密码，不得将账号出租、出借或转让给他人使用；</p>
        <p>您应遵守本协议及我们公布的其他规则（如《社区规范》《操作指南》）；</p>
        <p>您同意我们通过电话、短信或小程序推送等方式向您发送服务通知、安全提醒等必要信息。</p>

        <h3>第四条 数据使用与保护</h3>
        <h4>4.1 数据收集目的</h4>
        <p>我们仅在以下情形下收集您的个人信息：</p>
        <ul>
          <li>报名活动（比赛、展演、考级等）；</li>
          <li>为您提供证书查询服务（需核验身份证号码与姓名匹配性）；</li>
          <li>查询快递物流单号信息（邮寄证书时使用）；</li>
          <li>优化服务体验（如记录查询历史以便快速访问）；</li>
          <li>履行法律义务（如配合监管机构调查）。</li>
        </ul>
        <h4>4.2 数据共享与披露</h4>
        <p>我们不会主动向第三方共享您的个人信息，但以下情形除外：</p>
        <ul>
          <li>经您明确授权（如授权发证机构核验信息真实性）；</li>
          <li>为提供服务必需，与合作伙伴签订保密协议（如云服务商、支付机构）；</li>
          <li>响应法律要求，配合司法、行政机关调查。</li>
        </ul>
        <h4>4.3 数据安全措施</h4>
        <p>我们采用加密传输、匿名化处理、访问控制等技术保护您的数据安全；</p>
        <p>我们定期对员工进行数据安全培训，并限制内部人员访问权限。</p>

        <h3>第五条 知识产权</h3>
        <p>5.1 本小程序内的所有内容（包括但不限于文字、图片、代码、界面设计）的知识产权归我们或合法授权方所有；</p>
        <p>5.2 未经我们书面许可，您不得复制、传播、修改或创建衍生作品，否则将承担法律责任。</p>

        <h3>第六条 免责声明</h3>
        <h4>6.1 查询结果偏差</h4>
        <p>因您输入信息错误、发证机构数据更新延迟或第三方数据源问题导致的查询结果不准确，我们不承担责任；</p>
        <p>本服务展示的证书信息仅供参考，具体法律效力以发证机构官方文件为准。</p>
        <h4>6.2 服务中断</h4>
        <p>因不可抗力（如自然灾害、网络攻击）、第三方服务故障或必要维护导致的服务中断，我们不承担赔偿责任，但将尽快恢复服务。</p>
        <h4>6.3 用户损失</h4>
        <p>您因违反本协议或法律法规导致的损失，由您自行承担；</p>
        <p>我们对您的间接损失（如商业机会丧失、名誉损害）不承担赔偿责任。</p>

        <h3>第七条 违约责任</h3>
        <h4>7.1 若您违反本协议约定，我们有权采取以下措施：</h4>
        <ul>
          <li>警告、限制或终止服务；</li>
          <li>删除违规内容或冻结账号；</li>
          <li>追究法律责任（如要求赔偿因侵权或违约导致的损失）。</li>
        </ul>
        <h4>7.2 若我们违反本协议约定，您有权要求我们改正或赔偿直接损失。</h4>

        <h3>第八条 协议变更与通知</h3>
        <p>8.1 我们有权根据业务发展或法律法规要求修改本协议，修改后将通过小程序公告、邮件或推送通知您；</p>
        <p>8.2 若您在协议变更后继续使用本服务，视为已接受修改内容。</p>

        <h3>第九条 法律适用与争议解决</h3>
        <p>9.1 本协议适用中华人民共和国法律；</p>
        <p>9.2 双方因本协议产生的争议应协商解决，协商不成可向运营方所在地人民法院提起诉讼。</p>

        <h3>第十条 附则</h3>
        <p>10.1 本协议未约定事项，参照《中华人民共和国民法典》《个人信息保护法》等相关法律法规执行；</p>
        <p>10.2 本协议条款标题仅为方便阅读，不影响条款实际含义；</p>
        <p>10.3 若本协议部分条款无效，不影响其他条款的效力。</p>
      `
    }
  },
  computed: {
    ...mapState(['statusObj'])
  },
  methods: {
    ...mapMutations(['setProductId']),
    clickComm(item) {
      // 测试直接跳转
      // this.$router.push('/MyScore?id=' + 4393)
      // this.$router.push('/MyDelivery?id=' + 4393)
      // return;

      this.userName = '';
      this.idCardNumber = '';
      this.openSelect = true;
      this.clickItem = item
    },
    queryOpus(queryType) {
      if (!this.isAgreed) {
        this.$toast("请先阅读并同意勾选用户协议和隐私政策")
        return;
      }
      console.log(this.userName)
      console.log(this.idCardNumber)

      this.queryType = queryType

      if (!this.userName) {
        this.$toast("请输入姓名")
        return;
      }
      if (!this.idCardNumber) {
        this.$toast("请输入身份证号")
        return;
      }
      // if (this.idCardNumber.length != 18) {
      //   this.$toast("身份证号格式错误")
      //   return;
      // }

      // 查作品列表
      let param = {activityId: this.clickItem.activityId, userName: this.userName, idCardNumber: this.idCardNumber}

      this.$http.post('/spInfo/getOpusList', param).then(res => {
        if (res.data.length == 0) {
          this.$toast("未查询到相关信息")
          return;
        }
        this.opus = res.data
        this.openOpus = true
      })
    },
    goOpus(item, index) {
      if (this.queryType == 'delivery') {
        this.$router.push('/MyDelivery?id=' + item.id)
      }
      if (this.queryType == 'score') {
        this.$router.push('/MyScore?id=' + item.id)
      }
    },
    // 新增显示 WebView 方法
    showWebView(type) {
      if (type === 'userAgreement') {
        // this.currentAgreementTitle = '《用户服务协议》';
        this.agreementContent = this.fuwuxieyi
        // this.currentAgreementUrl = '/user-agreement.html'; // 替换为实际的用户协议 HTML 文件路径
      } else if (type === 'privacyPolicy') {
        // this.currentAgreementTitle = '《隐私政策》';
        this.agreementContent = this.yinsizhengce

        this.currentAgreementUrl = '/privacy-policy.html'; // 替换为实际的隐私政策 HTML 文件路径
      }
      this.showWebViewModal = true;
    },
    // 新增隐藏 WebView 方法
    hideWebView() {
      this.showWebViewModal = false;
    }
  }
}
</script>

<style scoped>
.label {
  width: 70px;
  color: #1A1A1A;
  font-size: 14px;
  font-weight: 500;
}

.btn {
  margin-bottom: 20px;
  width: 220px;
  height: 40px;
  color: #FF7216;
  border-radius: 5px;
  font-size: 18px;
  border: 1px solid #FF7216;
  background: #FFF;
}

.list_box {
  flex: 1 1 auto;
  overflow-y: auto;
}

.list_box .list_item {
  display: flex;
  align-items: flex-start;
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
  padding: 15px;
}

.list_box .list_item:active {
  background-color: #f1f1f1;
}

.list_box .list_item .leftImg {
  width: 80px;
  height: 80px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 4px;
}

.list_box .list_item .leftImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.list_box .list_item .rightBox {
  flex: 1 1 auto;
  margin-left: 12px;
  padding-top: 4px;
}

.list_box .list_item .rightBox .title {
  font-size: 15px;
  color: #333;
  margin-bottom: 4px;
}

.list_box .list_item .rightBox .desc {
  font-size: 12px;
  color: #999;
  display: none;
  margin-bottom: 4px;
}

.list_box .list_item .rightBox .state {
  font-size: 12px;
  /*color: orangered;*/
  margin-bottom: 4px;
}

.list_box .list_item .rightBox .other {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.list_box .list_item .rightBox .other .price {
  color: #ff6400;
  font-weight: 600;
}

.list_box .list_item .rightBox .other .num {
  color: orangered;
}
</style>



// WEBPACK FOOTER //
// src/components/InfoList.vue